import {AccessRights} from "lib/constants/accessRights";
import { createSelector } from "reselect";

export const hasEmployeeAddAccessRightSelector = createSelector(
    state => state.profile.accessRights,
    (accessRights, registrationType, subscriptionPlan, usersCount) => {
        if (!accessRights.includes(AccessRights.Employee.WRITE_CREATE)) {
            return false
        }

        return true
    }
);

export const canAccess = createSelector(
  (state, accessRightName) => {
    if (typeof accessRightName !== 'string') return false;

    let readState = false;
    if (accessRightName.endsWith('.read') && accessRightName.split('.').length <= 3) {
        readState = state.profile.accessRights.includes(accessRightName);
        accessRightName = accessRightName.replace('.read', '.write');
    }

    return state.profile.accessRights.includes(accessRightName) || readState;
  },
  (hasAccessRight) => hasAccessRight,
);
